import * as React from "react";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {
    changeRefreshProfileStatus,
    getCreditScore,
    getProfile, saveProfile,
    setFlag,
} from "userform/actions";
import {IBankStatementStatus, IDocument, ILoanApprovalInfo, ILoanInfo, IProfile, LoginChannel} from "StateInterface";
import "./styles.scss";
import {getDocumentsToApply, getFlag, getV3Fields, Screens, v3Screens} from "userform/utils";
import {getPathName, isEmail} from "utils";
import classnames from "classnames";
import {flagged} from "reducers/flagTools";
import {Flags} from "reducers/flagActions";
import Loading from "components/loading";
import {Link} from "react-router-dom";
import * as request from "request";
import LeftPanel from "userform/leftpanel";
import {RouteComponentProps} from "react-router-dom";
import {applyUrl, imageBaseUrl} from "../config";

interface IConnectProps {
    dispatch?: (action: any) => void;
    existing: boolean;
    email: string;
    authUserId: number;
    profile: IProfile;
    documents: IDocument[];
    bankStatement: IBankStatementStatus;
    roles: any;
    fetchAllInfo: boolean;
    flags: Flags[];
    consentFlags: Flags[];
    loading: boolean;
    isServiceable: boolean;
    completedDetails: any;
    refreshProfile: boolean;
    location: any;
    config: any;
    loanApplicationStatus: string;
    loanApplicationInfo: any;
    loanApprovalInfo: ILoanApprovalInfo;
    pathname: string;
    search: string;
    availableBankStatement: boolean;
    bankStatementMandatory: boolean;
    initialLoginChannel: string;
    currentFlowChannel: string;
    loanInfo: ILoanInfo;
    isAndroid: boolean;
}

interface IProps {
    router: any;
}

interface IState {
    email: string;
    errorMsg: string;
    navExpand: boolean;
    landingPageSet: boolean;
}

const formList: string[] = ["PERSONAL", "FINANCIAL", "DOCUMENTS", "REFERENCES"];

type FinalProps = IProps & IConnectProps;
class UserformV3 extends React.Component<FinalProps & RouteComponentProps, IState> {
    private profileRef = null;
    constructor(props) {
        super(props);
        this.state = {
            email: null,
            errorMsg: null,
            navExpand: false,
            landingPageSet: true,
        };

        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.displayReferralLink = this.displayReferralLink.bind(this);
        this.handleReloadToV2(props);
    }
    public onChangeHandler(fieldName, value) {
        this.setState({ email: value });
    }

    public handleNavClick() {
        this.setState({ navExpand: !this.state.navExpand });
    }

    public componentWillMount() {
        this.props.dispatch(getProfile(this.props.authUserId));
        this.props.dispatch(getCreditScore(this.props.authUserId));

        // TODO: move the kommunicatebot loading to dispatch!
        if (!(window as any).kommunicate && !(this.props.isAndroid)) {
            this.addKommunicateBot((window as any).kommunicate || {}, this.props.email, this.props.authUserId);
        }
        // this.getContacts();
    }

    public componentWillReceiveProps(newProps) {
        if (newProps.refreshProfile) {
            this.props.dispatch(getProfile(newProps.authUserId));
            this.props.dispatch(getCreditScore(newProps.authUserId));
            this.props.dispatch(changeRefreshProfileStatus(false));
        } else if (this.redirectConsent(newProps)) {
            const path = getPathName(newProps.pathname);
            this.props.history.push({pathname: path === "/" ? "/consent" : `${path}/consent`, search: newProps.search});
            // this.props.dispatch(push({pathname: path === "/" ? "/consent" : `${path}/consent`, search: newProps.search}));

        }
        if (newProps.profile && !newProps.profile.loanRequest && newProps.loanInfo) {
            const profile: IProfile = JSON.parse(JSON.stringify(newProps.profile));
            profile.loanRequest = JSON.parse(JSON.stringify(newProps.loanInfo));
            this.props.dispatch(saveProfile(profile, null));
        }
        this.handleReloadToV2(newProps);
    }
    public handleReloadToV2(props) {
        const redirectToRoute = this.redirectConsent(props) ? "consent/" : "";
        if (props.currentFlowChannel && props.initialLoginChannel) {
            if (props.currentFlowChannel.slice(-2) === "V3" &&
                props.initialLoginChannel.slice(-2) !== "V3"
            ) {
                window.location.href = `${applyUrl}#/${this.props.isAndroid ? `android/${redirectToRoute}` : ""}?id_token=${(window as any).getToken()}`;
            }
        }
    }
    public redirectConsent(props) {
        return props.consentFlags !== null && props.consentFlags.length !== 0  && props.consentFlags[0] !== null;
    }

    public getContacts() {
        const url = `https://www.google.com/m8/feeds/contacts/default/full`;
        request.get(url).on("response", (response) => {
            return;
        });
    }

    public handleLinkClick(screen, flag) {
        const completePage = this.props.completedDetails ? this.props.completedDetails.v3CompletePages : [];
        if (completePage.indexOf(screen) !== -1) {
            this.props.dispatch(setFlag(flag, true));
            this.setState({navExpand: false});
        }
    }

    public getFormLinks() {
        const completedPages = this.props.completedDetails ? this.props.completedDetails.v3CompletePages : [];
        const links = [];
        const screens = v3Screens.filter((s) => s !== Screens.GET_STARTED);
        if (flagged(this.props.flags, Flags.showGetStarted)) {
            links.push({
                title: Screens.GET_STARTED,
                screen: Screens.GET_STARTED,
                flag: Flags.showGetStarted,
                completed: false,
            });
        }
        screens.map((page, index) => {
            links.push({
                title: page,
                screen: page,
                flag: getFlag(page),
                completed: completedPages.indexOf(page) !== -1,
            });
        });

        return <LeftPanel
            navExpand={this.state.navExpand}
            bgColor={this.props.config.leftPanelBgColor}
            textColor={this.props.config.leftPanelTextColor}
            textColorActive ={this.props.config.btnColor}
            onclick={this.handleLinkClick}
            links={links}
            flag={this.props.flags[0]}
            email={this.props.email} />;
    }
    public displayReferralLink() {
        if (!this.props.isAndroid) {
            return (
                <div className="formContainer" style={{padding: "0px", marginTop: "20px"}}>
                    <Link to="referralLink" style={{
                        textDecoration: "none",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <img src={`${imageBaseUrl}/img/referImg.png`} alt="Refer" style={{width: "65%"}}/>
                    </Link>
                </div>
            );
        }
    }
    public render() {
        const btnClassName = classnames("form-link-toggle d-md-none p-0 col-1",
            { collapsed: this.state.navExpand });
        return (
            <div className="form-container container-fluid">
                <Loading
                    active={this.props.loading} />
                <div className="form-row row row-eq-height flex-xl-nowrap background-color">
                    <div className="col-lg-3 col-md-4 mt-3 pl-md-5 form-left-container">
                        <div>
                            {!this.props.isAndroid &&
                                <i className={`${btnClassName} ${this.state.navExpand ? "fa fa-close" : "fa fa-bars"}`}
                                   style={{color: "rgb(139, 139, 139)", fontSize: "20px", float: "right"}}
                                   data-toggle="collapse"
                                   data-target="#nav-form-links" aria-controls="nav-form-links"
                                   aria-expanded={this.state.navExpand}
                                   onClick={this.handleNavClick}
                                   aria-label="Toggle docs navigation"
                                />
                            }
                        </div>
                        {this.getFormLinks()}
                    </div>
                    <div className="col-lg-9 col-md-8 mt-4 form-middle-container">
                        <div className="form-card side-padding">
                            {this.displayReferralLink()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private addKommunicateBot(m: any, email: string, userId: number) {
        const o = {
            appId: "29bc19e4ff002556a54c2c9087ff5bdfb",
            isAnonymousChat: true,
            conversationTitle: "Hello!",
            userId,
            userName: email,
            email,
            botIds: ["shubh-bot"],
        };
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://api.kommunicate.io/kommunicate.app";
        document.getElementsByTagName("head")[0].appendChild(s);
        (window as any).kommunicate = m;
        m._globals = o;
    }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    return {
        existing: auth ? auth.existing : false,
        roles: auth ? auth.roles : null,
        email: auth ? auth.email : null,
        authUserId: auth ? auth.userId : null,
        profile: state.userform.userStatus ? state.userform.userStatus.profileStatus : null,
        documents: state.documents.documents,
        bankStatement: state.userform.userStatus ? state.userform.userStatus.bankStatementsStatus : null,
        fetchAllInfo: state.userform.fetchAllInfo,
        flags: state.userform.flagsV3,
        loading: state.userform.loading,
        isServiceable: state.userform.userStatus ? state.userform.userStatus.isServiceable : true,
        completedDetails: state.userform.completionDetails,
        refreshProfile: state.userform.refreshUserStatus,
        location: state.router.location,
        config: state.userform.config,
        loanApplicationStatus: state.userform.userStatus
            ? (state.userform.userStatus.latestApplicationsStatus.loanApplicationInfo
                ? state.userform.userStatus.latestApplicationsStatus.loanApplicationInfo.status : null) : null,
        loanApprovalInfo: state.userform.userStatus && state.userform.userStatus.latestApplicationsStatus
            ?  state.userform.userStatus.latestApplicationsStatus.loanApprovalInfo : null,
        loanApplicationInfo: state.userform.userStatus && state.userform.userStatus.latestApplicationsStatus
            ?  state.userform.userStatus.latestApplicationsStatus.loanApplicationInfo : null,
        pathname: state.userform.param,
        search: state.userform.search,
        consentFlags: state.consent.flags,
        availableBankStatement: state.userform.userStatus ?
            state.userform.userStatus.bankStatementsStatus.available.length > 0 : false,
        bankStatementMandatory: state.userform.bankStatementMandatory,
        initialLoginChannel: state.consent.initialLoginChannel,
        currentFlowChannel: state.login.currentFlowChannel,
        loanInfo: state.userform.loanInfo,
        isAndroid: state.login.isAndroid
    };
};

export default connect<IConnectProps, IProps, {}>(mapStateToProps)(UserformV3);
